module.exports = __webpack_public_path__ + "img/gift_2x.5a7a9065.png";